import script from "./workPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./workPreview.vue?vue&type=script&setup=true&lang=js"

import "./workPreview.vue?vue&type=style&index=0&id=3addb52e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3addb52e"]])

export default __exports__